
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitosolapur() {



    const cardData =
    {
        keyword: 'Mumbai to Solapur Cab Booking',
        heading: 'Skyline Cabs: Mumbai to Solapur Cab Booking',
        headingDescription: '​Skyline Cabs offers a reliable and comfortable Mumbai to Solapur Cab Service, ensuring a smooth journey to this historic city. Whether you are traveling for business, leisure, or a spiritual visit, our well-maintained vehicles and professional drivers guarantee a hassle-free experience.​​​',

        top: 'Top Places to Visit in prayagraj with Skyline Cabs',

"topPlaces": [
    {
        "title": "Siddheshwar Temple",
        "description": "The Siddheshwar Temple is one of the most important temples in Solapur, dedicated to Lord Siddheshwar, a manifestation of Lord Shiva. Located on the banks of the Bhima River, the temple attracts devotees from all over the region and is an important pilgrimage site."
    },
    {
        "title": "Solapur Fort",
        "description": "The Solapur Fort is a historical fort that offers a glimpse into the city's rich past. The fort, built during the reign of the Bahmani Sultanate, is an important part of Solapur's history and is a popular spot for tourists interested in medieval architecture."
    },
    {
        "title": "Nannaj Bird Sanctuary",
        "description": "Located near Solapur, the Nannaj Bird Sanctuary is famous for its migratory birds, especially the Indian bustard. It is a haven for birdwatchers and nature lovers, offering peaceful surroundings and a chance to observe wildlife in their natural habitat."
    },
    {
        "title": "Bhuikot Fort",
        "description": "Bhuikot Fort is another historical fort in Solapur, known for its ruins and historical significance. The fort was built during the Maratha period and is a popular destination for history enthusiasts and photographers who enjoy capturing the remnants of this ancient structure."
    },
    {
        "title": "Gurudwara Nanakwadi",
        "description": "Gurudwara Nanakwadi is a significant place of worship for the Sikh community in Solapur. The Gurudwara offers a peaceful and spiritual atmosphere for devotees and visitors who wish to experience the Sikh culture and traditions."
    },
    {
        "title": "Tembhurni",
        "description": "Tembhurni is a small town near Solapur known for its ancient temples, particularly the temple of Lord Vitthal. The town offers a serene environment and is an important spot for devotees who visit to seek the blessings of the deity."
    },
    {
        "title": "Maa Shree Pundalik Temple",
        "description": "Located on the outskirts of Solapur, the Maa Shree Pundalik Temple is dedicated to Lord Vithoba and is one of the well-known pilgrimage sites in the area. The temple offers a serene and tranquil atmosphere for devotees."
    },
    {
        "title": "Shri Mallikarjun Temple",
        "description": "The Shri Mallikarjun Temple is another important religious site in Solapur, dedicated to Lord Mallikarjun, a form of Lord Shiva. The temple is known for its spiritual significance and attracts pilgrims, especially during festivals."
    },
    {
        "title": "Solapur Lake",
        "description": "Solapur Lake is an artificial lake located within the city, providing a beautiful spot for a peaceful retreat. It’s a perfect location for picnics, leisurely walks, and to enjoy the tranquility of nature."
    },
    {
        "title": "Shri Siddhivinayak Temple",
        "description": "Shri Siddhivinayak Temple is dedicated to Lord Ganesha and is known for its unique architecture. It is one of the prominent temples in Solapur and attracts devotees who seek blessings for success and prosperity."
    }
],

"services": [
    {
      "name": "Mumbai to Solapur Cab",
      "description": "Skyline Cabs provides comfortable and dependable cab services from Mumbai to Solapur. Travel long-distance with ease in our well-maintained vehicles."
    },
    {
      "name": "Solapur Taxi from Mumbai",
      "description": "Book a taxi from Mumbai to Solapur with Skyline Cabs. Our experienced drivers ensure a smooth and safe journey to your destination."
    },
    {
      "name": "Mumbai to Solapur One Way Taxi",
      "description": "Rent a one-way taxi from Mumbai to Solapur with Skyline Cabs. A convenient and cost-effective option for single-way travel."
    },
    {
      "name": "Taxi Booking from Mumbai to Solapur",
      "description": "Easily book your taxi from Mumbai to Solapur with Skyline Cabs. Flexible booking options and reliable service guaranteed."
    },
    {
      "name": "Solapur Darshan Taxi Service",
      "description": "Explore Solapur’s religious and cultural spots with Skyline Cabs’ darshan taxi service. Ideal for pilgrims and tourists alike."
    }
  ],
  "tableData": [
    ["Mumbai to Solapur Cab", "Solapur Taxi from Mumbai"],
    ["Mumbai to Solapur One Way Taxi", "Taxi Booking from Mumbai to Solapur"],
    ["Solapur Darshan Taxi Service"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Mumbai to Solapur Cab Booking",
      "WhyChoosedescription": "Book a reliable and comfortable cab for your journey from Mumbai to Solapur. Whether it's for business, religious visits, or leisure, we ensure a smooth and stress-free ride."
    },
    {
      "WhyChooseheading": "Comfortable and Long-Distance Ready Cabs",
      "WhyChoosedescription": "Our cabs are designed for long-distance travel with spacious interiors, air conditioning, and smooth suspension, ensuring comfort for your trip from Mumbai to Solapur."
    },
    {
      "WhyChooseheading": "Experienced and Courteous Drivers",
      "WhyChoosedescription": "Our professional drivers are experienced with long-distance travel and the Mumbai-Solapur route, providing safe, timely, and courteous service throughout your journey."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer affordable, clear, and upfront pricing for your Mumbai to Solapur cab journey, with no hidden charges, ensuring complete transparency in your booking."
    },
    {
      "WhyChooseheading": "Perfect for Business, Religious, or Personal Travel",
      "WhyChoosedescription": "Whether you're heading to Solapur for business, a religious visit to the Pandharpur temple, or a family trip, our cab service caters to all travel needs."
    },
    {
      "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
      "WhyChoosedescription": "Every vehicle is thoroughly cleaned, sanitized, and regularly maintained to ensure safety, hygiene, and comfort during your trip."
    },
    {
      "WhyChooseheading": "Flexible Travel Options",
      "WhyChoosedescription": "Choose from one-way, round-trip, or extended stay packages based on your travel plans. We provide flexible options to accommodate your schedule."
    },
    {
      "WhyChooseheading": "24/7 Customer Support and Easy Booking",
      "WhyChoosedescription": "Book your cab easily online or over the phone. Our 24/7 customer support team is available to assist you with booking, travel queries, or any changes to your schedule."
    }
  ]
  
  
  
  
  








    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Solapur with Skyline Cabs?',
            answer:
                'Booking your cab from Mumbai to Solapur is easy. You can book online through our website, mobile app, or by calling our customer support. Simply provide your pickup location in Mumbai, travel date, and vehicle type to confirm your booking.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Mumbai to Solapur?',
            answer:
                'The distance from Mumbai to Solapur is approximately 350 km. The travel time typically ranges from 6 to 8 hours, depending on traffic and road conditions.',
        },
        {
            id: 3,
            question: 'What vehicle options are available for the Mumbai to Solapur journey?',
            answer:
                'Skyline Cabs offers a range of vehicles for the journey, including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs. For larger groups, we also offer Tempo Travellers and mini-buses.',
        },
        {
            id: 4,
            question: 'Are the cab fares from Mumbai to Solapur fixed?',
            answer:
                'Yes, our fares are fixed and transparent. The fare includes vehicle rent, driver allowance, fuel, tolls, taxes, and any other applicable fees. You will be informed of the total fare upfront, so there are no surprises.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab from Mumbai to Solapur?',
            answer:
                'Yes, you can book a one-way cab from Mumbai to Solapur. We also offer round-trip services if you need a return journey at a later time.',
        },
        {
            id: 6,
            question: 'Are stopovers allowed during the Mumbai to Solapur journey?',
            answer:
                'Yes, we allow short stopovers for meals, refreshments, or sightseeing along the way. You can let the driver know if you did like to take a break or visit any specific places on the route.',
        },
        {
            id: 7,
            question: 'What payment options are available for the Mumbai to Solapur cab?',
            answer:
                'We accept various payment methods including UPI, credit/debit cards, net banking, and cash. Online payments are securely processed through trusted payment gateways.',
        },
        {
            id: 8,
            question: 'Can I cancel or modify my Mumbai to Solapur booking?',
            answer:
                'Yes, you can modify or cancel your booking through our website, mobile app, or by contacting customer support. We offer flexible cancellation policies to accommodate any changes in your plans.',
        },
        {
            id: 9,
            question: 'Is the long-distance journey from Mumbai to Solapur safe?',
            answer:
                'Absolutely. Skyline Cabs ensures a safe and comfortable long-distance journey. Our vehicles are well-maintained and equipped with safety features, and our drivers are experienced with intercity travel.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for the Mumbai to Solapur trip?',
            answer:
                'Skyline Cabs provides a comfortable, reliable, and affordable journey from Mumbai to Solapur. With professional drivers, well-maintained vehicles, fixed pricing, and excellent customer service, your trip will be smooth and enjoyable.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Anil Deshmukh",
            rating: 5,
            review: "I traveled from Mumbai to Solapur with Skyline Cabs, and the experience was great. The driver was professional, and the car was clean and comfortable. The journey was smooth, and I highly recommend this service for long-distance travel!"
        },
        {
            name: "Miss. Priya Sharma",
            rating: 4,
            review: "The trip was good overall, and the driver was punctual. The only improvement would be to have more frequent stops along the way, but other than that, everything was excellent!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Solapur Cab Booking",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-solapur-cab.jpg",
  "description": "Book Mumbai to Solapur cab with Skyline Cabs for a smooth and reliable journey. Choose AC sedans, SUVs, or luxury cabs with professional drivers, fixed pricing, and 24/7 customer support.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8423"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4799",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-solapur-cab-booking"
  }
};

      
      
      


    return (
        <div>

<Helmet>
  <title>Mumbai to Solapur Cab Booking | 24/7 Outstation Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Solapur cab with Skyline Cabs for a smooth and reliable journey. Choose AC sedans, SUVs, or luxury cabs with professional drivers, fixed pricing, and 24/7 customer support." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Solapur Cab, Solapur Taxi from Mumbai, One Way Cab to Solapur, AC Cab Mumbai Solapur, SUV Taxi Mumbai to Solapur, Mumbai to Solapur Outstation Taxi, Skyline Cabs Booking, Affordable Cab Solapur, 24/7 Cab Service Mumbai to Solapur, Luxury Cab to Solapur" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/108.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitosolapur;